var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:[
		'c-video-player',
		`c-video-player--is-${_vm.picker.provider.alias}`,
	]},_vm.$listeners),[(_vm.picker && _vm.isEmbedded)?_c(_vm.getPlayerComponent(_vm.picker.provider.alias),_vm._b({ref:"player",tag:"Component",staticClass:"c-video-player__player",class:_vm.playerClassNames,style:(_vm.playerStyles),attrs:{"data":_vm.picker}},'Component',_vm.$attrs,false)):_vm._e(),_vm._v(" "),(_vm.$scopedSlots.overlay)?_c('div',{staticClass:"c-video-player__overlay"},[_vm._t("overlay",null,null,_vm.slotProps)],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }